<!--
  ~ Copyright (C) 2024 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="calendar-integration-prompt">
  <div class="calendar-integration-prompt__content">
    <span class="calendar-integration-prompt__message">{{ data.message }}</span>
    <button mat-button class="calendar-integration-prompt__link" (click)="onGoToSettings()">
      {{ 'translations.calendarIntegration.prompt.goToSettings' | transloco }}
    </button>
  </div>
  <button
    mat-icon-button
    class="calendar-integration-prompt__close"
    [attr.aria-label]="'translations.global.ariaLabels.close' | transloco"
    (click)="onDismiss()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
